import React from "react";
import "./status.css";

const StatusChip = ({ status }) => {
  // Functions
  const getStyle = () => {
    switch (status) {
      case "paid":
      case "created":
      case "accepted":
      case "in_transit":
      case "at_destination":
      case "completed_by_provider":
      case "completed":
        return {
          color: "rgb(var(--success)",
          backgroundColor: "rgb(var(--success), 0.05)",
        };
      case "cancelled":
      case "cancelled_due_Payment":
      case "cancelled_by_supplier":
      case "cancelled_by_client":
        return {
          color: "rgb(var(--error))",
          backgroundColor: "rgb(var(--error), 0.05)",
        };
      case "in_progress":
        return {
          color: "rgb(var(--warning))",
          backgroundColor: "rgb(var(--warning), 0.05)",
        };
      default:
        return {
          backgroundColor: "gray",
          color: "white",
        };
    }
  };

  // Variables
  const style = getStyle();

  return (
    <div className="description ChipColor" style={style}>
      {status?.replace(/_/g, " ")}
    </div>
  );
};

export default StatusChip;
